module.exports = __webpack_public_path__ + "img/burden.f28339d8.svg";